import { mapGetters, mapActions } from 'vuex'
import Detail from './detail.dialog.vue'
import manuscript from '@/api/manuscript'
import question from '@/api/questionnaire'
import authorSelection from './author-selection'

export default {
  components: {
    Detail,
    authorSelection
  },
  data() {
    return {
      isVisable: false,
      params: {
        username: ''
      },
      questionList: [],
      flag1: false,
      flag2: false,
      authorSelectVisable: false,
      inputData: []
      // flag3: false
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      manuscript: 'getManuscript',
      publisherInfo: 'getPublisherInfo',
      domain: 'getDomain',
      user: 'getUser'
    })
  },
  watch: {
    manuscript: {
      handler(val) {
        if (val.id) {
          let { questionList, version, sign, id } = val
          this.params = {
            version,
            sign,
            id
          }
          if (questionList && questionList.length) {
            this.questionList = questionList
            this.questionList.forEach(item => {
              if (item.type === 'SINGLE') {
                item.checkedOption = +item.checkedOption
              } else if (item.type === 'MULTIPLE' && item.checkedOption) {
                item.checkedOptions = item.checkedOption.split(';')
              }
            })
          } else {
            this.getQuestion()
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['updateManuscript']),
    async submit() {
      if (!this.params.username) {
        this.$message.error({
          title: 'Error',
          content: 'Please enter your name'
        })
        return
      }
      const flag = this.questionList.some(item => {
        if (
          item.type === 'MULTIPLE' &&
          item.checkedOptions &&
          item.checkedOptions.length
        ) {
          item.checkedOption = item.checkedOptions.join(';')
        }
        if (
          item.required &&
          !(item.answer || item.checkedOption || item.checkedOption === 0)
        ) {
          return true
        }
      })
      if (flag) {
        this.$message.error({
          title: 'Error',
          content: 'Please complete the questionnaire'
        })
        return
      }
      // const flagAuthor = this.manuscript.authorList.some(
      //   item => item.email === this.user.email
      // )
      const flagAuthor = await manuscript.replace({
        manuscriptId: this.manuscript.id
      })
      this.params.questionList = this.questionList
      if (
        flagAuthor.isReplace &&
        !this.params.mauthorId &&
        this.manuscript.sign === 1 &&
        this.manuscript.status === 'UNCOMMITTED'
      ) {
        this.authorSelectVisable = true
        this.inputData = this.manuscript.authorList
        return
      }

      const res = await manuscript.step5(this.params)
      this.updateManuscript(res)

      if (this.$route.path.includes('/eidtor-task')) {
        this.$router.push(
          '/editorial-office/manuscripts/details/' + this.manuscript.id
        )
      } else {
        await this.$confirm({
          content: `<div class="ipub-h2 main-color mar-b-30">Manuscript No. ${this.manuscript.code}</div><div class="ipub-p1 main-color mar-b-10" style="font-size:20px">You have submitted your manuscript successfully.</div><div class="mar-b-20 ipub-p2 main-color" style="width: 400px;margin: 0 auto">Your manuscript is already sent to our editors. We will review it within 7 days and contact you by email.</div>`,
          type: 'success',
          width: '600px',
          showConcel: false,
          showTitle: false,
          confirmText: 'View My Submission'
        })
          .then(async () => {
            this.$router.push('/author/submitted-manuscripts')
          })
          .catch(async () => {
            this.$router.push('/author/submitted-manuscripts')
          })
      }
    },
    async getQuestion() {
      this.questionList = await question.getAll({
        name: 'SUBMIT',
        enabled: true,
        journalId: this.manuscript.journal.id
      })
      this.questionList.forEach(item => {
        item.questionId = item.id
        item.id = ''
      })
    },
    preview() {
      this.isVisable = true
    },
    cancel() {
      this.isVisable = false
      this.authorSelectVisable = false
    },
    goToPage(val) {
      this.cancel()
      setTimeout(() => {
        this.$router.push(val)
      })
    },
    confirmAuthor(val) {
      this.params.mauthorId = val
      this.authorSelectVisable = false
    }
  }
}
